import client from '@general/graphql/client';

let apolloClient;

const initApollo = () => {
    const _apolloClient = apolloClient ?? client;
    if (!apolloClient) apolloClient = _apolloClient;

    return _apolloClient;
};

export default initApollo;
